import { render, staticRenderFns } from "./ManagementTabPanel.vue?vue&type=template&id=432fc7f9&scoped=true"
import script from "./ManagementTabPanel.vue?vue&type=script&lang=js"
export * from "./ManagementTabPanel.vue?vue&type=script&lang=js"
import style0 from "./ManagementTabPanel.vue?vue&type=style&index=0&id=432fc7f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432fc7f9",
  null
  
)

export default component.exports